import * as React from 'react';

import * as styles from './styles.css';

export function Skeleton() {
  return (
    <div data-testid="newbuilding-carousel-skeleton" className={styles['container']}>
      <div className={styles['preview']} />
      <div className={styles['content']}>
        {[1, 2, 3].map(item => (
          <div key={item} className={styles['line']} />
        ))}
      </div>
    </div>
  );
}
